import React from "react";

import * as ListItem from "../ListItem";
import styles from "../styles.module.css";

function WithImageOnLeft(props: ListItem.Props) {
  const { description, timestamp, image } = props;

  return (
    <article className={styles.listItemContainer}>
      <div className={styles.leftColumn} data-skeleton-selector>
        {image && <ListItem.Image {...props} />}
        {!image && timestamp && <ListItem.Timestamp {...props} />}
      </div>
      <div className={styles.mainColumn} data-skeleton-selector>
        <ListItem.Text {...props} />
        {description && <ListItem.Description {...props} />}
      </div>
    </article>
  );
}
WithImageOnLeft.displayName = "WithImageOnLeft.Component";

export { WithImageOnLeft };

export * from "./Themed";
